<template>
    <div :id="id" :class="['area flex m-no-pad', Classes().area]" :style="`width: ${width}`">
        <img class="icon" :src="Icon()" :alt="`Icon - ${process.label}`" :title="process.label" width="100" height="100"/>
        <div class="content single">
            <p class="label">{{ process.label }}</p>
            <div class="divider"></div>
            <div class="items">
                <p v-for="(item, i) in process.items" :key="i">{{ item.Name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { Animation } from "@/assets/JS/Animation.js";
import { CONFIG } from "@/assets/JS/Config.js";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailProcessArea",
    props: {
        id: String,
        process: Object,
        totalAreas: Number,
        contentInitiated: Boolean,
        index: Number,
        mobile: Boolean
    },
    data: () => ({
        width: "",
        icon: ""
    }),
    methods: {
        Icon: function() {
            let icon = "";
            switch(this.process.label) {
                case "Tools":
                    icon = "IconTools.png";
                    break;
                case "Languages & Frameworks":
                    icon = "IconLanguages.png";
                    break;
            }
            return require(`@/assets/Images/${icon}`);
        },
        Classes: function() {
            return {
                area: !this.mobile ? "" : "m-area"
            }
        }
    },
    beforeMount: function() {
        let width = "";
        if (this.totalAreas > 1) {
            width = `${100 / this.totalAreas}%`;
        } else {
            width = "30%";
        }
        if (this.mobile) {
            width = "100%";
        }
        this.width = width;
    },
    mounted: function() {

        // Animate in
        const $instance = $(`#${this.id}`);
        const duration = !this.contentInitiated
            ? CONFIG.projects.detailContentAnimationSpeed
            : 0;
        const instance = this;
        new Animation($instance.find(".icon"), "Fade", 1, duration, 0, function() {
            if (instance.index === 0) {
                instance.$emit("content-initiated", "Process");
            }
        });
        new Animation($instance.find(".items"), "Fade Top", 1, duration, 0);

    },
    emits: [ ...projectModel.emits ]
};
</script>